import { computed, ref } from 'vue'

// the dataavailable event is triggered after ca 1 second chunks
const REQUEST_DATA_INTERVAL_MS = 1000

export const useRecording = () => {
  const recorder = ref<MediaRecorder>()
  const isRecording = computed(() => typeof recorder.value !== 'undefined')

  const reset = () => {
    recorder.value = undefined
  }

  async function startRecording(availableHandler?: (audioBlob: Blob) => Promise<void>): Promise<boolean> {
    if (typeof recorder.value !== 'undefined') {
      return false
    }

    try {
      const stream = await navigator.mediaDevices.getUserMedia({ audio: true })
      recorder.value = new MediaRecorder(stream, { mimeType: 'audio/webm; codecs=opus' })
    } catch {
      return false
    }

    recorder.value.ondataavailable = async event => {
      if (availableHandler) {
        await availableHandler(event.data)
      }
    }

    recorder.value.start(REQUEST_DATA_INTERVAL_MS)
    return true
  }

  async function stopRecording(): Promise<boolean> {
    if (typeof recorder.value === 'undefined') {
      return false
    }

    recorder.value.requestData()
    recorder.value.stop()

    reset()
    return true
  }

  return { startRecording, stopRecording, isRecording }
}
